import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * ActivateConversationStream
 *
 * @private
 */
export const activateConversationStream = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.actions.rpc.routingAssistant.ActivateConversationStreamAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/routing-assistant/activateConversationStream', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/routing-assistant/activateConversationStream', {
      category: 'rpc',
      type: 'rpc/routing-assistant/activateConversationStream',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on activateConversationStream`,
      { tags: ['rpc', 'routing-assistant'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `activateConversationStream call failed`,
      error,
    })
  }
})
